import {
    SET_SGIP_VALUE,
    SET_SGIP_TOGGLE,
} from './constants';


export const setSGIPValue = sgipValue => ({
    type: SET_SGIP_VALUE,
    sgipValue,
});

export const setSGIPToggle = sgipToggle => ({
    type: SET_SGIP_TOGGLE,
    sgipToggle,
});



// WEBPACK FOOTER //
// ./src/containers/common/sgip/actions.js